import { useApiConfiguration } from 'src/ui/shared/hooks/api-configuration.hook';
import { useIsCareerHubVersion } from 'src/ui/shared/hooks/is-careerhub-version.hook';

export const useIsErsEnabled = () => {
    const v5_17 = useIsCareerHubVersion(5, 17);
    const { value } = useApiConfiguration();
    return v5_17 && value?.settings?.disableVerifications !== true;
};
